<template>
  <!-- <div class="card" v-if="compSel">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Edit '+compSel.companyname}}</strong>
        </div>
        <div class="col-md-1" v-if="isFromComp === 1">
          <a
            class="btn btn-sm btn-small btn-success"
            @click.prevent="showDetailView(companyDetails)"
          >
            <i :title="'View Details'" class="fa fa-eye cwhite"></i>
          </a>
          <a
            class="btn btn-sm btn-small btn-warning"
            @click.prevent="viewCalculatedData(companyDetails)"
          >
            <i :title="'Calculated Data'" class="fa fa-calculator cwhite"></i>
          </a>
        </div>
        <div class="col-md-1" v-if="isFromComp === 1">
          <goback></goback>
        </div>
      </div>
    </div>
  <div class="card-body">-->
  <div class>
    <div class="mb5"></div>
    <!-- <vform :formData="editForm" :fields="fields" :submitCallback="showSmallModal"/> -->
    <form @onsubmit.prevent action>
      <div v-for="field in fields" class="row form-group" v-bind:key="field.name">
        <div class="col col-md-4">
          <label :for="field.name" class="form-control-label">{{field.label}}</label>
        </div>
        <div class="col col-md-4">
          <div v-if="field.type == 'inline-checkbox'" class="form-check">
            <div v-for="option in field.options" class="checkbox" v-bind:key="option.label">
              <label for="checkbox1" class="form-check-label">
                <input
                  v-model="formData[field.name]"
                  type="checkbox"
                  :value="option.value"
                  :name="field.name"
                  class="form-check-input"
                >
                {{option.label}}
              </label>
            </div>
          </div>
          <div v-else-if="field.type == 'inline-radio'" class="form-check-inline form-check">
            <label
              v-for="option in field.options"
              class="form-check-label"
              style="padding:0px 10px;"
              v-bind:key="option.label"
            >
              <input
                v-model="formData[field.name]"
                type="radio"
                :name="field.name"
                class="form-check-input"
                :value="option.value"
              >
              {{option.label}}
            </label>
          </div>
          <input
            v-else
            type="field.type"
            v-model="formData[field.name]"
            id="field.name"
            :placeholder="field.placeholder"
            class="form-control"
          >
          <small v-if="errors[field.name]" class="form-text text-danger">{{errors[field.name]}}</small>
          <small v-else-if="field.help" class="form-text text-muted">This is a help text</small>
        </div>
        <div class="col-md-2" v-for="rel in field.reletedField" v-bind:key="rel.name">
          <input
            type="rel.type"
            v-model="formData[rel.name]"
            id="rel.name"
            :placeholder="rel.placeholder"
            class="form-control"
          >
          <small v-if="errors[rel.name]" class="form-text text-danger">{{errors[rel.name]}}</small>
          <small v-else-if="rel.help" class="form-text text-muted">This is a help text</small>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group pull-right">
            <button @click="saveMacroData" type="button" class="btn btn-primary">Save</button>
            <button @click="updateMacroData" type="button" class="btn btn-primary">Save & Update</button>
          </div>
        </div>
      </div>
    </form>
    <PinCheck
      :show.sync="show"
      ref="smallModal"
      v-bind:small="true"
      @submitForm="submitForm"
      :cancelClass="'btn btn-secondary'"
    ></PinCheck>
  </div>
  <!-- </div>
  </div>-->
</template>
<script>
// import vform from "@/components/vform";
import http from "@/lib/http";
import PinCheck from "@/components/PinCheck.vue";
export default {
  components: { PinCheck },
  props: ["companyData", "isFromComp", "selCompany"],
  created() {},
  data() {
    return {
      company: {},
      compSel: {},
      show: false,
      fields: [
        {
          label: "Has durable competitive advantage?",
          name: "has_durable_competitive_advantage",
          type: "inline-radio",
          value: 0,
          options: [
            {
              label: "Yes",
              value: 1
            },
            {
              label: "No",
              value: 0
            }
          ]
        },
        {
          label: "Is it a cyclical stock?",
          name: "is_it_a_cyclical_stock",
          type: "inline-radio",
          value: 1,
          options: [
            {
              label: "Yes",
              value: 1
            },
            {
              label: "No",
              value: 0
            }
          ]
        },
        {
          label: "Target Interest Coverage Ratio",
          name: "target_interest_coverage_ratio",
          type: "text",
          value: 4
        },
        {
          label: "Interest Rate (%)",
          name: "interest_rate",
          type: "text",
          value: 10
        },
        {
          label: "projected Period",
          name: "projected_period",
          type: "text",
          value: 10
        },
        {
          label: "Estimated long-term EPS growth rate (%)",
          name: "estimated_long_term_eps_growth_rate",
          type: "text",
          value: 0.15
        },
        {
          label: "Analyst's consensus EPS growth estimate of current year  (%)",
          name: "analysts_consensus_eps_growth_estimate_of_current_year",
          type: "text",
          value: 0.15
        },
        {
          label:
            "Analyst's consensus EPS growth estimate of the year following the current year (compared with the current year)  (%)",
          name:
            "analyst_consensus_eps_growth_estimate_of_the_year_following_the_current_year",
          type: "text",
          value: 0.15
        },
        {
          label: "Sustainable Earnings growth",
          name: "sustainable_earning_growth",
          type: "text",
          value: 4
        }
      ],
      formData: {},
      errors: []
    };
  },
  methods: {
    submitEditForm: function(s) {
      let myself = this;
      console.log("submit form", this.formData);
      //{editComp: this.formData},
      http.post(
        "updateFinalData/" + this.company.co_code,
        this.formData,
        (error, callback) => {
          this.$toastr.success("Updated Successfully!", "", {});
        }
      );
    },
    setData() {
      this.fields = [
        {
          label: "Has durable competitive advantage?",
          name: "has_durable_competitive_advantage",
          type: "inline-radio",
          value: this.company.has_durable_competitive_advantage,
          options: [
            {
              label: "Yes",
              value: 1
            },
            {
              label: "No",
              value: 0
            }
          ]
        },
        {
          label: "Is it a cyclical stock?",
          name: "is_it_a_cyclical_stock",
          type: "inline-radio",
          value: parseInt(this.company.is_it_a_cyclical_stock),
          options: [
            {
              label: "Yes",
              value: 1
            },
            {
              label: "No",
              value: 0
            }
          ]
        },
        {
          label: "Target Interest Coverage Ratio",
          name: "target_interest_coverage_ratio",
          type: "text",
          value: this.company.target_interest_coverage_ratio
            ? this.company.target_interest_coverage_ratio
            : 4
        },
        {
          label: "Interest Rate (%)",
          name: "interest_rate",
          type: "text",
          value: this.company.interest_rate ? this.company.interest_rate : 10
        },
        {
          label: "Projected Period",
          name: "projected_period",
          type: "text",
          value: this.company.projected_period
            ? this.company.projected_period
            : 10
        },
        {
          label: "Estimated long-term EPS growth rate (%)",
          name: "estimated_long_term_eps_growth_rate",
          type: "text",
          value: this.company.estimated_long_term_eps_growth_rate
            ? this.company.estimated_long_term_eps_growth_rate
            : 15
        },
        {
          label: "Analyst's consensus EPS growth estimate of current year (%)",
          name: "analysts_consensus_eps_growth_estimate_of_current_year",
          type: "text",
          value: this.company
            .analysts_consensus_eps_growth_estimate_of_current_year
            ? this.company
                .analysts_consensus_eps_growth_estimate_of_current_year
            : 15
        },
        {
          label:
            "Analyst's consensus EPS growth estimate of the year following the current year (compared with the current year) (%)",
          name:
            "analyst_consensus_eps_growth_estimate_of_the_year_following_the_current_year",
          type: "text",
          value: this.company
            .analyst_consensus_eps_growth_estimate_of_the_year_following_the_current_year
            ? this.company
                .analyst_consensus_eps_growth_estimate_of_the_year_following_the_current_year
            : 15
        },
        {
          label: "Sustainable Earnings growth",
          name: "sustainable_earning_growth",
          type: "text",
          value: this.company.sustainable_earning_growth
            ? this.company.sustainable_earning_growth
            : 4
        }
      ];
    },
    setFormData() {
      for (var index in this.fields) {
        let field = this.fields[index];
        if (!field.placeholder) field.placeholder = "";
        if (
          field.name !== "has_durable_competitive_advantage" &&
          field.name !== "is_it_a_cyclical_stock"
        ) {
          if (!field.value) field.value = "";
        }
        if (!field.help) field.help = "";
        this.formData[field.name] = this.company[field.name];
        this.$set(this.formData, field.name, field.value);
      }
      console.log("this.formData", this.formData);
    },
    getFixed(num) {
      let n = parseFloat(num).toFixed(2);
      return n != "NaN" ? n : "-";
    },
    cancel(d) {
      console.log("Cancel =>", d);
    },
    submitForm() {
      console.log("submitpin entered");
      // this.validatePin(pin);
      this.submitEditForm();
    },
    showSmallModal() {
      this.$refs.smallModal.open();
    },
    saveMacroData() {
      this.formData["update"] = 0;
      this.$refs.smallModal.open();
    },
    updateMacroData() {
      this.formData["update"] = 1;
      this.$refs.smallModal.open();
    },
    getRawData() {
      http.get(
        "getUpdatedCompnayWiseData/" + this.company.co_code,
        {},
        (error, response) => {
          if (response.data.length > 0) {
            this.company = response[0];
            this.setFields();
            this.setFormData();
          }
        }
      );
    }
  },
  watch: {
    companyData: function(value) {
      console.log("Sel comp Value", value);
      this.company = value;
      for (var i in value) {
        this[i] = value[i];
      }
      this.setData();
      this.setFormData();
    },
    selCompany: function(value) {
      this.compSel = value;
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/company/editCompany.vue